'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	sanitizeSubTeamName = subteamName => {
		const sane =  subteamName && subteamName.trim();
		return sane.replace(/\s+/g, ' ');
	};

require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');


mmWidgets.fn.subteamCreateWidget = function (subteamModel) {
	if (!subteamModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			nameElement = element.find('[data-mm-role~="sub-team-name"]'),
			showError = reason => {
				nameElement.parent().addClass('error');
				element.find('[data-mm-role~="error"]').addClass('hidden');
				element.find(`[data-mm-role~="error"][data-mm-reason~="${reason}"]`).removeClass('hidden');
			},
			clearError = () => {
				nameElement.parent().removeClass('error');
				element.find('[data-mm-role~="error"]').addClass('hidden');
			};
		element.on('show', () => {
			clearError();
			nameElement.val('');
			element.showSection('initial');
		});
		element.find('[data-mm-role~="create-sub-team"]').click(() => {
			const name = nameElement.val(),
				sane = sanitizeSubTeamName(name);
			nameElement.val(sane);
			if (!sane) {
				return showError('no-sub-team-name');
			} else if (sane.length < 3) {
				return showError('too-short-sub-team-name');
			} else if (sane.length > 30) {
				return showError('too-long-sub-team-name');
			}
			element.showProgressMessage('Creating new subteam, please wait..');
			return subteamModel.create(sane)
			.then(() => {
				element.addClass('hidden');
				element.trigger('createComplete');
			})
			.catch(reason => {
				element.showError(reason);
				element.trigger('createFailed');
			});
		});
	});
};
